/* Meadow Gift customer-local delivery window. */
(function () {
  'use strict';

  if (window.MG_DELIVERY_READY) return;
  window.MG_DELIVERY_READY = true;
  window.MG = window.MG || {};

  var timers = [];

  function integer(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function pad(value) { return String(value).padStart(2, '0'); }

  function key(date) {
    return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate());
  }

  function day(year, month, date) { return new Date(Date.UTC(year, month, date)); }

  function addCalendarDays(date, amount) {
    var next = new Date(date.getTime());
    next.setUTCDate(next.getUTCDate() + amount);
    return next;
  }

  function observed(date) {
    var weekday = date.getUTCDay();
    if (weekday === 6) return addCalendarDays(date, -1);
    if (weekday === 0) return addCalendarDays(date, 1);
    return date;
  }

  function nthWeekday(year, month, weekday, nth) {
    var first = day(year, month, 1);
    var offset = (7 + weekday - first.getUTCDay()) % 7;
    return day(year, month, 1 + offset + ((nth - 1) * 7));
  }

  function lastWeekday(year, month, weekday) {
    var last = day(year, month + 1, 0);
    return addCalendarDays(last, -((7 + last.getUTCDay() - weekday) % 7));
  }

  function federalHolidays(year) {
    return [
      observed(day(year, 0, 1)),
      nthWeekday(year, 0, 1, 3),
      nthWeekday(year, 1, 1, 3),
      lastWeekday(year, 4, 1),
      observed(day(year, 5, 19)),
      observed(day(year, 6, 4)),
      nthWeekday(year, 8, 1, 1),
      nthWeekday(year, 9, 1, 2),
      observed(day(year, 10, 11)),
      nthWeekday(year, 10, 4, 4),
      observed(day(year, 11, 25))
    ];
  }

  function holidaySet(year, extra) {
    var set = new Set();
    [year - 1, year, year + 1, year + 2].forEach(function (value) {
      federalHolidays(value).forEach(function (date) { set.add(key(date)); });
    });
    String(extra || '').split(',').forEach(function (value) {
      var clean = value.trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(clean)) set.add(clean);
    });
    return set;
  }

  function isBusinessDay(date, holidays) {
    var weekday = date.getUTCDay();
    return weekday !== 0 && weekday !== 6 && !holidays.has(key(date));
  }

  function nextBusinessDay(date, holidays) {
    var next = date;
    do { next = addCalendarDays(next, 1); } while (!isBusinessDay(next, holidays));
    return next;
  }

  function addBusinessDays(date, amount, holidays) {
    var next = date;
    var remaining = Math.max(0, amount);
    while (remaining > 0) {
      next = addCalendarDays(next, 1);
      if (isBusinessDay(next, holidays)) remaining -= 1;
    }
    return next;
  }

  function browserTimezone(fallback) {
    try {
      var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return timezone || fallback;
    } catch (err) { return fallback; }
  }

  function zonedParts(now, timezone) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(now);
    var output = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') output[part.type] = parseInt(part.value, 10);
    });
    return output;
  }

  function calculate(config, now, timezone) {
    now = now || new Date();
    timezone = timezone || browserTimezone(config.fallbackTimezone || 'America/Denver');
    var parts = zonedParts(now, timezone);
    var orderDay = day(parts.year, parts.month - 1, parts.day);
    var minDays = Math.max(0, integer(config.minCalendarDays, 1));
    var maxDays = Math.max(minDays, integer(config.maxCalendarDays, 6));

    return {
      min: addCalendarDays(orderDay, minDays),
      max: addCalendarDays(orderDay, maxDays),
      timezone: timezone
    };
  }

  function formatDate(date, includeYear) {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC', month: 'short', day: 'numeric', year: includeYear ? 'numeric' : undefined
    }).format(date);
  }

  function formatRange(result) {
    var includeYear = result.min.getUTCFullYear() !== result.max.getUTCFullYear();
    return formatDate(result.min, includeYear) + '–' + formatDate(result.max, includeYear);
  }

  function formatDates(min, max) {
    var includeYear = min.getUTCFullYear() !== max.getUTCFullYear();
    return formatDate(min, includeYear) + '–' + formatDate(max, includeYear);
  }

  function configFor(node) {
    return {
      minCalendarDays: node.getAttribute('data-delivery-min-days'),
      maxCalendarDays: node.getAttribute('data-delivery-max-days'),
      fallbackTimezone: node.getAttribute('data-fallback-timezone') || 'America/Denver'
    };
  }

  function render(node, now, timezone) {
    if (!node) return null;
    var deliveryOutput = node.querySelector('[data-mg-delivery-range]');
    if (!deliveryOutput) return null;
    try {
      var result = calculate(configFor(node), now || new Date(), timezone);
      deliveryOutput.textContent = formatRange(result);
      node.setAttribute('data-state', 'ready');
      node.setAttribute('data-timezone', result.timezone);
      return result;
    } catch (err) {
      node.setAttribute('data-state', 'fallback');
      return null;
    }
  }

  function boot(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = Array.prototype.slice.call(root.querySelectorAll('[data-mg-delivery]'));
    if (root.matches && root.matches('[data-mg-delivery]')) nodes.unshift(root);
    nodes.forEach(function (node) {
      if (node.getAttribute('data-mg-delivery-ready') === 'true') return;
      node.setAttribute('data-mg-delivery-ready', 'true');
      render(node);
      timers.push(window.setInterval(function () { render(node); }, 60000));
    });
  }

  window.MG.deliveryEstimate = { calculate: calculate, render: render, formatRange: formatRange, formatDates: formatDates };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
